// const API_BASE = window.vehicleConfig.apiBase;
// const API_KEY = window.vehicleConfig.apiKey;
// console.log(API_BASE);
const SERVICE_NAME = window.vehicleConfig.productTitle;
// console.log('test');

document.addEventListener('DOMContentLoaded', function () {

    const car = getSavedCar();

    if (car) {
        processVehicle(car);
    }

});

document.addEventListener('vehicle:selected', function (e) {

    processVehicle(e.detail);

});

async function processVehicle(car) {

    try {

        const response = await fetch(
            `${API_BASE}/calculate_price`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Api-Key': API_KEY
                },
                body: JSON.stringify({
                    brand: car.brand,
                    model: car.model,
                    services: [
                        SERVICE_NAME
                    ]
                })
            }
        );

        const data = await response.json();

        console.log(data);

        if (data.status !== 'success') {

            return;

        }

        const carSize = data.car_size;
        console.log("Car Size :", carSize);
console.log(window.productVariants);
        setVehicleHiddenFields(
            car.brand,
            car.model,
            carSize
        );

      const test = selectVariantBySize(carSize);
        console.log("test sizing" . test);
    }
    catch (error) {

        console.error(error);

    }

}

function setVehicleHiddenFields(
    brand,
    model,
    size
) {

    const brandInput =
        document.getElementById('cartCarBrand');

    const modelInput =
        document.getElementById('cartCarModel');

    const sizeInput =
        document.getElementById('cartCarSize');

    if (brandInput)
        brandInput.value = brand;

    if (modelInput)
        modelInput.value = model;

    if (sizeInput)
        sizeInput.value = size;

}

function selectVariantBySize(size) {

    document
    .querySelectorAll('input[name="service_variant"]')
    .forEach(radio => {

        const title =
            radio.nextElementSibling
            .innerText
            .trim();

        if (
            title.toLowerCase() ===
            size.toLowerCase()
        ) {

            radio.checked = true;

            radio.dispatchEvent(
                new Event('change', {
                    bubbles: true
                })
            );

        }

    });

}
document
.querySelectorAll('input[name="service_variant"]')
.forEach(radio => {

    radio.addEventListener('change', function () {

        document.querySelector('.product-variant-id').value =
            this.value;

        updatePriceByVariant(this.value);

    });

});

function updatePriceByVariant(variantId){

        const variant = window.productVariants.find(
            v => v.id == variantId
        );

        if(!variant) return;

        const price = (variant.price /100).toFixed(2);

        document.querySelector('.price-item--regular').innerHTML = '₹' + price;

        document.getElementById('cartServicePrice').value = price;
    }
async function checkServiceInCart() {

    try {

        const cart = await fetch('/cart.js').then(r => r.json());

        const currentProductId = Number(window.vehicleConfig.productId);

        const exists = cart.items.some(item =>
            Number(item.product_id) === currentProductId
        );

        console.log("Current Product:", currentProductId);
        console.log("Exists:", exists);

        const btn =
            document.querySelector('button[name="add"]');

        console.log("Button:", btn);

        if (!btn) return;

        if (exists) {

            btn.disabled = true;

            btn.innerHTML = "Already Added";

            btn.classList.add("disabled");

            btn.style.pointerEvents = "none";
            btn.style.opacity = "0.6";

        } else {

            btn.disabled = false;

            btn.innerHTML = "Add Service";

            btn.classList.remove("disabled");

            btn.style.pointerEvents = "auto";
            btn.style.opacity = "1";

        }

    } catch (e) {

        console.error(e);

    }

}
document.addEventListener('cart:changed', () => {

    setTimeout(() => {

        checkServiceInCart();

    }, 300);

});